import React from 'react';
import { ZapIcon, ArrowRightIcon, LockIcon, RefreshCwIcon, StarIcon, CheckCircleIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-cream py-10 px-4" data-id="element-316">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-317">
        {/* Main Headline */}
        <h1 className="text-[28px] sm:text-[32px] leading-[1.3] font-bold text-brand-black mb-4" data-id="element-318">
          <ZapIcon className="inline-block w-8 h-8 text-primary mb-1 mr-2" data-id="element-319" />
          Aprende Comandos Eléctricos desde Cero y Convierte Esta Habilidad en
          Ingresos Semanales
        </h1>

        {/* Subtitle */}
        <p className="text-dark-gray text-base sm:text-lg leading-relaxed mb-6 max-w-[500px] mx-auto" data-id="element-320">
          Descubre cómo esta habilidad puede ayudarte a generar entre $200 y
          $1,000 por semana con una guía visual paso a paso para entender
          diagramas, montar tableros y realizar trabajos mejor pagados.
        </p>

        {/* Product Image */}
        <div className="mb-8 mx-auto max-w-[500px]" data-id="element-321">
          <img src="https://cdn.magicpatterns.com/uploads/oTG63tToJqGPpUVcKnsGwh/imagen_principal.png" alt="Domina los Comandos Eléctricos" className="w-full h-auto block drop-shadow-2xl" width="500" height="500" fetchPriority="high" decoding="async" data-id="element-322" />
        </div>

        {/* CTA */}
        <a href="https://dominaelcontrol.online/cart/50664044626153:1" onClick={() => window.fbq && window.fbq('track', 'AddToCart')} className="animate-pulse-big flex items-center justify-center gap-2 max-w-[400px] mx-auto bg-gradient-to-br from-success to-emerald-600 text-white border-none py-4 px-6 text-lg font-bold rounded-full cursor-pointer shadow-[0_8px_20px_rgba(34,197,94,0.3)] text-center uppercase tracking-wide no-underline mb-4 hover:translate-y-[-3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(34,197,94,0.4)] transition-all duration-400" data-id="element-323">
          QUIERO DOMINAR LOS COMANDOS ELÉCTRICOS
          <ArrowRightIcon className="w-5 h-5" data-id="element-324" />
        </a>

        {/* Trust Badges */}
        <div className="flex flex-col items-center gap-2 mt-4 text-sm text-dark-gray font-medium" data-id="element-325">
          <div className="flex items-center gap-3" data-id="element-326">
            <span className="flex items-center gap-1" data-id="element-327">
              <LockIcon className="w-4 h-4 text-primary" data-id="element-328" /> Garantía 7 Días
            </span>
            <span data-id="element-329">·</span>
            <span className="flex items-center gap-1" data-id="element-330">
              <ZapIcon className="w-4 h-4 text-primary" data-id="element-331" /> Acceso Inmediato
            </span>
          </div>
          <div className="flex items-center gap-1" data-id="element-332">
            <RefreshCwIcon className="w-4 h-4 text-primary" data-id="element-333" /> Actualizaciones
            diarias de por vida
          </div>
          <div className="bg-[#1A1D24] border border-white/10 rounded-full px-4 py-1.5 flex items-center gap-2 mt-1" data-id="element-334">
            <div className="flex text-primary" data-id="element-335">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-336" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-337" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-338" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-339" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-340" />
            </div>
            <span className="text-white font-bold text-xs" data-id="element-341">
              4.9/5{' '}
              <span className="text-dark-gray font-normal" data-id="element-342">
                +12.500 Electricistas
              </span>
            </span>
            <CheckCircleIcon className="w-4 h-4 text-blue-500 fill-white" data-id="element-343" />
          </div>
        </div>
      </div>
    </section>;
}